import {
  GET_PROSTATE_TOTAL_SUCCESS,
  GET_PROSTATE_TOTAL_FAIL,
  UPDATE_PROSTATE,
} from "../actions/_actionType";

export default function prostateRe(
  state = {
    prostateData: {
      age: 40,
      sex: true,
      kg: 70,
      cm: 170,
      dmyn: false, // 당뇨
      hpyn: false, // 고혈압
      pa: false, // 운동량
      smoking: false,
      smokingGap: 0,
      gapYear: 0,
    },
    total: 0,
    complete: false,
  },
  action
) {
  switch (action.type) {
    case UPDATE_PROSTATE:
      return {
        ...state,
        prostateData: action.payload.datas,
      };
    case GET_PROSTATE_TOTAL_SUCCESS:
      return {
        ...state,
        total: action.total,
        complete: true,
      };
    case GET_PROSTATE_TOTAL_FAIL:
      return {
        ...state,
        total: action.total,
        complete: true,
      };

    default:
      return state;
  }
}
